@if (source(); as src) {
  <img
    [src]="src"
    [alt]="name"
    [class.loaded]="state() === 'loaded'"
    (load)="loaded()"
    (error)="failed()"
  />
}
@if (state() === 'loading') {
  <div class="image-skeleton" aria-hidden="true"></div>
} @else if (state() === 'unavailable') {
  <div
    class="image-placeholder"
    [class.compact]="compact"
    role="img"
    [attr.aria-label]="t.getMarketplacePhotoUnavailableText()"
  >
    <mat-icon aria-hidden="true">photo_camera</mat-icon>
    @if (!compact) {
      <span>{{ t.getMarketplacePhotoUnavailableText() }}</span>
    }
  </div>
}
